import store from "../../store";
store.dispatch('setDevice', '');
store.getters.device.isPC ? console.log("") : store.dispatch('setMobileRoute', 'mobile/');
let mPath = store.getters.mobileRoute;

export default [
  // {
  //   path: '',
  //   // component: () => import('@/components/layout/Layout.vue'),
  //   // 暂时将天刀活动页作为首页
  //   redirect: '/cloudGame/8bd999',
  // },
  {
    path: '/cloudGame/:id',
    name: 'cloudGame',
    component: () => import('@/views/pages/cloudgame/CloudGame.vue'),
  },
  {
    path: '/cloudGame/referrer/:id',
    name: 'cloudGame',
    component: () => import('@/views/errors/302.vue'),
  },
  {
    path: '/cloudGame/login/test2',
    name: 'cloudGameLoginTest2',
    component: () => import('@/views/pages/cloudgame/CloudGameLoginTest3.vue'),
  },
  {
    path: '/cloudGame/login/test3',
    name: 'cloudGameLoginTest3',
    component: () => import('@/views/pages/cloudgame/CloudGameLoginTest3.vue'),
  },
  {
    path: '/cloudGame/policy/cookiesPolicy',
    name: 'cloudGame',
    component: () => import('@/views/pages/cloudgame/cookieBanner/components/cookiesPolicy.vue'),
  },
];
